<template>
  <el-table ref="multipleTable" :data="list" :span-method="objectSpanMethod" style="width: 100%" height="100%" border>
    <!-- <el-table-column type="selection" width="55" v-if="type === 2">
    </el-table-column> -->
    <el-table-column width="55" v-if="type === 2">
      <template slot-scope="scope">
        <el-checkbox v-model="scope.row.isCheck"
          @change="(val) => { handleSelectione(val, scope.row.name) }"></el-checkbox>
      </template>
    </el-table-column>
    <el-table-column prop="name" :label="$t('ctce2')" width="180">
    </el-table-column>
    <el-table-column prop="point" :label="$t('cdca6')">
    </el-table-column>
    <el-table-column :label="$t('cbpl01')" width="100">
      <template slot-scope="scope">
        {{ scope.row.radius }}km
      </template>
    </el-table-column>
    <el-table-column prop="play_name" :label="$t('cbpl02')">
    </el-table-column>
    <el-table-column label="操作" width="144" v-if="type === 1">
      <template slot-scope="scope">
        <el-button type="primary" size="mini">{{ $t('csu7') }}</el-button>
        <el-button type="danger" size="mini" @click="delPoint(scope.row.name)">{{ $t('csu9') }}</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: "PointList",
  props: {
    type: {
      type: Number,
      default: 1
    },
    mergeCells: {
      type: Array,
      default: () => [0, 4]
    },
    isOneSelect: {
      type: Boolean,
      default: true
    },
    pointList: {
      type: Array,
      required: true,
      default: () => []
    },
  },
  data() {
    return {
      checkedName: "",
      list: [],
    }
  },
  watch: {
    pointList: {
      immediate: true,
      handler(n) {
        this.list = n;
      }
    },
  },
  created() {
    this.list = this.pointList;
  },
  methods: {
    delPoint(name) {
      let ids = this.list.filter(p => p.name == name).map(p => p.id);
      this.$http.post("/admin/device/delPoint", {
        ids: ids.join(",")
      }, () => {
        this.getPoint();
      });
    },
    handleSelectione(val, checkedName) {
      this.checkedName = checkedName;
      const checkList = []
      this.list = this.list.map(p => {
        if (p.name === checkedName) {
          checkList.push(p);
        }
        p.isCheck = p.name === checkedName;
        return p;
      });

      this.$emit("checkList", checkList)
    },
    // eslint-disable-next-line no-unused-vars
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (this.mergeCells.indexOf(columnIndex) != -1) { // 只在第一列（Name 列）合并单元格  
        const prevRow = this.list[rowIndex - 1];
        if (prevRow && prevRow.name === row.name) {
          return {
            rowspan: 0,
            colspan: 1,
          };
        } else {
          let count = 1;
          let nextRow = this.list[rowIndex + 1];
          while (nextRow && nextRow.name === row.name) {
            count++;
            nextRow = this.list[rowIndex + count];
          }
          return {
            rowspan: count,
            colspan: 1,
          };
        }
      }
      return {
        rowspan: 1,
        colspan: 1,
      };
    }
  }
}
</script>

<style lang="scss" scoped></style>